@if (rewardContent?.resultPrize) {
    <div class="results-prizes-block-images">
        <div class="results-prizes-shape">
            <img [attr.src]="rewardContent?.resultPrize?.backGroundShapeImage?.src" />
        </div>
        <div class="results-prizes-confetti" [style.background-image]="'url(' + rewardContent?.resultPrize?.confettiImage?.src + ')'">
            <img class="results-prizes-cup" [attr.src]="rewardContent?.resultPrize?.prizeCupImage?.src" />
        </div>
    </div>
    @if (rewardStatus) {
        <div class="results-prizes-block-content">
            <div class="results-prizes-title text-truncate" [vnDynamicHtml]="title"></div>
            @if (!currentlyAchievedPrizeModules) {
                <div class="used-prize"><span class="used-prize-icon theme-success-i"></span></div>
            }
            @if (currentlyAchievedPrizeModules && rewardContent?.resultPrize?.showCta) {
                <a
                    [attr.href]="rewardContent?.resultPrize?.checkPromoLink?.url"
                    target="{{
                        !!rewardContent?.resultPrize?.checkPromoLink?.attributes?.target
                            ? rewardContent?.resultPrize?.checkPromoLink?.attributes?.target
                            : ''
                    }}"
                    (click)="checkButtonClick(); $event.preventDefault()"
                    ds-button
                    size="medium"
                    variant="filled"
                    kind="primary"
                    >{{ rewardContent?.resultPrize?.checkPromoLink?.text }}</a
                >
            }
        </div>
    }
    @if (!rewardStatus) {
        <div class="results-prizes-block-content">
            <div class="results-prizes-title text-truncate" [vnDynamicHtml]="rewardContent?.resultPrize?.title"></div>
            @if (!currentlyAchievedPrizeModules) {
                <div class="used-time"><span class="used-time-icon theme-icons-time"></span></div>
            }
            @if (currentlyAchievedPrizeModules) {
                <button
                    grayoutStyle
                    ds-button
                    size="medium"
                    variant="filled"
                    kind="primary"
                    (click)="chooseReward(rewardContent?.resultPrize?.title)">
                    {{ clientContent?.messages?.choose }}
                </button>
            }
        </div>
    }
}
